'use client';

import { useDirection } from '@base-ui/react/direction-provider';
import {
  ArrowLeftOutlineIcon,
  ArrowRightOutlineIcon,
  ChevronLeftOutlineIcon,
  ChevronRightOutlineIcon,
} from '@fountain/ripple/icon';

/**
 * Arrows and chevrons named by reading direction rather than screen side.
 * Back and previous point toward the reading start, forward and next toward
 * its end, so on a right-to-left page `PreviousChevron` points right.
 */
export function useReadingDirectionIcons() {
  const isRightToLeft = useDirection() === 'rtl';

  return isRightToLeft
    ? {
        BackArrow: ArrowRightOutlineIcon,
        ForwardArrow: ArrowLeftOutlineIcon,
        NextChevron: ChevronLeftOutlineIcon,
        PreviousChevron: ChevronRightOutlineIcon,
      }
    : {
        BackArrow: ArrowLeftOutlineIcon,
        ForwardArrow: ArrowRightOutlineIcon,
        NextChevron: ChevronRightOutlineIcon,
        PreviousChevron: ChevronLeftOutlineIcon,
      };
}
